// extracted by mini-css-extract-plugin
export default {"closeButton":"PopUpLanguages_closeButton__n0Kj5","rounded":"PopUpLanguages_rounded__BO8Jp"};